import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useSchedulingStore } from '@src/store';
import { pushToDataLayer } from '@src/utils/pushToDataLayer';
const NewOrReturningGuestRadio = styled(Radio)(({
  theme
}) => ({
  '&.Mui-checked': {
    color: theme.palette.primary
  },
  '&:not(.Mui-checked)': {
    color: theme.palette.grey[400]
  }
}));
export const NewOrReturningGuest = () => {
  const {
    returningGuest,
    setReturningGuest
  } = useSchedulingStore(state => state);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value === 'true';
    setReturningGuest(value);
    const returningGuestStatus = value ? 'Existing' : 'New';
    const segmentType = value ? 1 : 0;
    // Braze event: 01 - Booking Started
    import('@src/utils/braze-exports').then(({
      logCustomEvent
    }) => {
      logCustomEvent('booking_started', {
        customerType: returningGuestStatus
      });
    });
    pushToDataLayer({
      event: 'appointment_step',
      stepName: 'select_patient_type',
      patientType: returningGuestStatus,
      segmentType: segmentType
    });
  };
  return <FormControl component="fieldset" data-sentry-element="FormControl" data-sentry-component="NewOrReturningGuest" data-sentry-source-file="NewOrReturningGuest.tsx">
			<RadioGroup row value={returningGuest ?? ''} onChange={handleChange} data-sentry-element="RadioGroup" data-sentry-source-file="NewOrReturningGuest.tsx">
				<FormControlLabel value={true} control={<NewOrReturningGuestRadio />} label={<Typography variant={returningGuest === true ? 'bodyMediumSemiBold' : 'bodyMediumBook'}>
							Yes
						</Typography>} checked={returningGuest === true} data-sentry-element="FormControlLabel" data-sentry-source-file="NewOrReturningGuest.tsx" />
				<FormControlLabel value={false} control={<NewOrReturningGuestRadio />} label={<Typography variant={returningGuest === false ? 'bodyMediumSemiBold' : 'bodyMediumBook'}>
							No
						</Typography>} checked={returningGuest === false} data-sentry-element="FormControlLabel" data-sentry-source-file="NewOrReturningGuest.tsx" />
			</RadioGroup>
		</FormControl>;
};
export default NewOrReturningGuest;